import React from "react";
import { DebtorInformation } from "us.collection.debtor/components";

const Cnt_DebtorInfo: React.FC = (props) => {

  return <DebtorInformation {...props} />;
};

export default Cnt_DebtorInfo;
